import React, { useEffect } from "react";
import 'step-indicator-pattern/dist/main.css';
import './StepIndicator.css';
import checkmarkIcon from '../../../public/assets/images/checkmarkIcon.svg';

export type StepStatus = "complete" | "active" | "inactive";

export interface StepIndicatorItem {
  label: string;
  status: StepStatus;
  errorCount?: number; // Optional: number of errors for this step
}

interface StepIndicatorProps {
  items: StepIndicatorItem[]; 
  domSelectorClassName?: string; 
  initializePattern?: boolean; 
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ items, domSelectorClassName = "ds-stepindicator", initializePattern = true }) => {
  const total = items.length;

  useEffect(() => {
    if (!initializePattern) return;
  import('step-indicator-pattern/dist/step-indicator-pattern.js')
      .then(mod => {
        try {
          const init = mod.default;
          if (typeof init === 'function') {
            init({ domSelector: domSelectorClassName.replace(/^\./, '') });
          }
        } catch (e) {
         
          console.warn('StepIndicator pattern init failed', e);
        }
      })
      .catch(err => {
        
        console.warn('StepIndicator pattern script not loaded', err);
      });
  }, [domSelectorClassName, initializePattern]);

  return (
    <div
      className={`${domSelectorClassName} custom-theme  lg:w-[332px] lg:shrink-0 `}
      data-ds-theme="vessel"
      data-ds-variant="vertical"
      data-ds-version="2"
      
    >
      <ul className="steps" aria-labelledby="si_1">
        {items.map((item, idx) => {

          const { label, status } = item;
          let positionClass = 'middle';
          if (idx === 0) positionClass = 'left';
          else if (idx === items.length - 1) positionClass = '-end';      
          let statusWord = '';
          if (status === 'complete') statusWord = 'Completed';
          else if (status === 'active') statusWord = 'Current Page';
          const srText = `Step ${idx + 1} Step ${idx + 1} of ${total}${statusWord ? ' ' + statusWord : ''}`;

          const getStatusColor = (status: StepStatus): string => {
            if (status === 'active') return '#000000';
            if (status === 'inactive') return '#677083';
            return '#0074AD';
          };

          return (
            <li key={label + idx} className={`${status} ${positionClass}`.trim()}>
              <div className="status">
              { status === 'complete' && <img src={checkmarkIcon} alt="" width={24} height={24} aria-hidden="true" />}
              </div>
              <span
                className="label"
                aria-hidden="true"
                style={{
                  fontWeight: status === 'active' ? 350 : 325,
                  // Set inactive to 14px (active already 14px). Keep completed at 12px.
                  fontSize: (status === 'active' || status === 'inactive') ? '14px' : '12px',
                  color: getStatusColor(status)
                }}
              >
                {label}
                {item.errorCount && item.errorCount > 0 && (
                  <span
                    style={{
                      marginLeft: '8px',
                      color: 'red',
                      padding: '2px 8px',
                      fontSize: '12px',
                      fontWeight: 500,
                      display: 'inline-block',
                    }}
                    aria-label={`${item.errorCount} error${item.errorCount === 1 ? '' : 's'}`}
                  >
                    {item.errorCount} {item.errorCount === 1 ? 'error' : 'errors'}
                  </span>
                )}
              </span>
              <span className="screenreader-only">{srText}</span>
            </li>
          );
          
        })}
      </ul>
    </div>
  );
};

export default StepIndicator;
